import { InvestorDetailsPacingTabCommitmentPlansQuery } from '@/__generated__/graphql';
import DropdownActions from '@/components/table/dropdownActions';
import NoResults from '@/components/table/noResults';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { TableBodyWrapper, TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { IItems } from '@/components/table/types';
import { getUTCDate } from '@/shared/utils/date';
import { useNavigate, useParams } from 'react-router-dom';
import { columns } from '../constants';

interface AllCommitmentPlansTableBodyProps {
  tableRows: InvestorDetailsPacingTabCommitmentPlansQuery['commitmentPlans']['data'];
  updateLoading: boolean;
  currentRow: InvestorDetailsPacingTabCommitmentPlansQuery['commitmentPlans']['data'][number] | null;
  dropdownActions: (row: InvestorDetailsPacingTabCommitmentPlansQuery['commitmentPlans']['data'][number]) => IItems[];
}

const AllCommitmentPlansTableBody = ({ tableRows, updateLoading, currentRow, dropdownActions }: AllCommitmentPlansTableBodyProps) => {
  const params = useParams();
  const navigate = useNavigate();

  const investorId = params?.investorId || '';
  const entityId = params?.entityId || '';

  if (!tableRows?.length) {
    return <NoResults />;
  }

  return (
    <TableBodyWrapper>
      {tableRows.map((row) => (
        <TableRowWrapper key={row.id} loading={updateLoading && row.id === currentRow?.id ? 1 : 0}>
          <TableRowCell width={columns[0].width}>
            <RedirectTitleCell
              onClick={() =>
                navigate(`/investors/${investorId}/${entityId}?backToTitle=All Commitment Plans&activeTab=Pacing&commitmentPlanId=${row.id}`)
              }
            >{`${row.name} ${row.active ? '(Active)' : ''}`}</RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={columns[1].width}>
            <TextCell>{getUTCDate(new Date(row.startDate))}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[2].width}>
            <TextCell>{row?.growthRate && `${row.growthRate.toFixed(2)}%`}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[3].width}>
            <DropdownActions disabled={updateLoading} items={dropdownActions(row)} />
          </TableRowCell>
        </TableRowWrapper>
      ))}
    </TableBodyWrapper>
  );
};

export default AllCommitmentPlansTableBody;
